import { render, staticRenderFns } from "./teachingtask.vue?vue&type=template&id=52b22f82&scoped=true"
import script from "./teachingtask.vue?vue&type=script&lang=js"
export * from "./teachingtask.vue?vue&type=script&lang=js"
import style0 from "./teachingtask.vue?vue&type=style&index=0&id=52b22f82&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b22f82",
  null
  
)

export default component.exports